import React, {useState} from 'react';
import {translate} from '@src/utils/languageTools';
import {ActionButton} from './ActionButton';

export const confirmButton = (table) => {
  return <ActionButton title={translate('Confirm')} onPress={() => table.confirmRecord()} />;
};
